import type { ButtonlayoutColorsType } from 'msp-integrations'

const buttonDefault =
  'font-medium relative flex flex-col outline-none group overflow-hidden items-center justify-center'

const contentDuration = 'duration-500'
const backgroundDuration = 'before:duration-500'

export const buttonLayoutColors: ButtonlayoutColorsType = {
  default: 'bg-black fill-white text-white border border-black',
  outline: 'bg-white fill-black text-black border border-black',
  danger:
    'bg-white fill-errorRed text-errorRed border border-errorRed hover:border-black',
  square: 'bg-coffee1-100 fill-black text-black'
}

export const skin = {
  primary: 'h-[48px] px-5 text-10 tracking-3',
  secondary: 'h-[42px] px-6 text-10 leading-18 tracking-3',
  tertiary: 'h-12 w-12 tracking-0'
}

const backgroundTransition = `
    before:absolute
    before:inset-0
    before:w-[125%]
    before:h-full
    before:-translate-x-full
    before:skew-x-12
    before:origin-bottom-right
    before:transition-transform
    before:will-change-transform
    md:hover:before:translate-x-0
`

export const backgroundTransitionColor: ButtonlayoutColorsType = {
  default: 'before:bg-white',
  outline: 'before:bg-black',
  danger: 'before:bg-black',
  square: 'before:bg-black'
}

const disabled = {
  default:
    'disabled:bg-machine2-25 disabled:text-machine2-75 disabled:fill-machine2-75 disabled:shadow-none disabled:pointer-events-none disabled:border-none',
  outline:
    'disabled:border-machine2-75 disabled:text-machine2-50 disabled:fill-machine2-50 disabled:shadow-none disabled:pointer-events-none'
}

const focused = {
  default: 'shadow-none focus:shadow-[0_0_8px_0_rgba(0,0,0,0.5)]',
  outline: 'shadow-none focus:shadow-[0_0_8px_0_rgba(0,0,0,0.1)]',
  square: 'shadow-none focus:shadow-[0_0_8px_0_rgba(208,198,188)]'
}

const active = 'active:shadow-none transition-shadow'

const contentDefault = `relative align-middle items-center justify-self-center`

export const contentColor: ButtonlayoutColorsType = {
  default:
    'md:group-hover:text-black md:group-hover:fill-black transition-colors',
  outline:
    'md:group-hover:text-white md:group-hover:fill-white transition-colors',
  square:
    'md:group-hover:text-white md:group-hover:fill-white transition-colors'
}

export const iconSizes = {
  default: {
    sm: {
      h: '14px',
      w: '14px'
    },
    md: {
      h: '16px',
      w: '16px'
    },
    lg: {
      h: '18px',
      w: '18px'
    }
  },
  square: {
    sm: {
      h: '20px',
      w: '20px'
    },
    md: {
      h: '22px',
      w: '22px'
    },
    lg: {
      h: '24px',
      w: '24px'
    }
  }
}

export const layouts = {
  primary: {
    default: {
      button: `${buttonDefault} ${disabled.default} ${focused.default} ${active}`,
      backgroundTransition: `${backgroundTransition} ${backgroundDuration}`,
      contentDiv: `${contentDefault} ${contentDuration}`
    },
    outline: {
      button: `${buttonDefault} ${buttonLayoutColors.outline} ${disabled.outline} ${focused.outline} ${active}`,
      backgroundTransition: `${backgroundTransition} ${backgroundDuration}`,
      contentDiv: `${contentDefault} ${contentDuration}`
    },
    danger: {
      button: `${buttonDefault} ${buttonLayoutColors.danger} ${disabled.outline} ${focused.outline} ${active}`,
      backgroundTransition: `${backgroundTransition} ${backgroundDuration}`,
      contentDiv: `${contentDefault} ${contentDuration}`
    }
  },
  secondary: {
    default: {
      button: `${buttonDefault} ${disabled.default} ${focused.default} ${active}`,
      backgroundTransition: `${backgroundTransition} ${backgroundDuration}`,
      contentDiv: `${contentDefault} ${contentDuration}`
    },
    outline: {
      button: `${buttonDefault} ${buttonLayoutColors.outline} ${disabled.outline} ${focused.outline} ${active}`,
      backgroundTransition: `${backgroundTransition} ${backgroundTransitionColor.outline} ${backgroundDuration}`,
      contentDiv: `${contentDefault} ${contentDuration}`
    },
    danger: {
      button: `${buttonDefault} ${buttonLayoutColors.danger} ${disabled.outline} ${focused.outline} ${active}`,
      backgroundTransition: `${backgroundTransition} ${backgroundDuration}`,
      contentDiv: `${contentDefault} ${contentDuration}`
    }
  },
  tertiary: {
    default: {
      button: `${buttonDefault} ${disabled.default} ${focused.square} ${active}`,
      backgroundTransition: `${backgroundTransition} ${backgroundDuration}`,
      contentDiv: `${contentDefault} ${contentDuration}`
    },
    outline: {
      button: `${buttonDefault} ${buttonLayoutColors.outline} ${disabled.outline} ${focused.outline} ${active}`,
      backgroundTransition: `${backgroundTransition} ${backgroundDuration}`,
      contentDiv: `${contentDefault} ${contentDuration}`
    },
    danger: {
      button: `${buttonDefault} ${buttonLayoutColors.danger} ${disabled.outline} ${focused.outline} ${active}`,
      backgroundTransition: `${backgroundTransition} ${backgroundDuration}`,
      contentDiv: `${contentDefault} ${contentDuration}`
    }
  }
}

export const centerLoadingContent =
  'absolute top-1/2 left-1/2 -translate-x-[50%] -translate-y-[50%]'
